import { render, staticRenderFns } from "./CfdiTypeCatalog.vue?vue&type=template&id=97ed43de"
import script from "./CfdiTypeCatalog.vue?vue&type=script&lang=js"
export * from "./CfdiTypeCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97ed43de')) {
      api.createRecord('97ed43de', component.options)
    } else {
      api.reload('97ed43de', component.options)
    }
    module.hot.accept("./CfdiTypeCatalog.vue?vue&type=template&id=97ed43de", function () {
      api.rerender('97ed43de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/CfdiTypeCatalog.vue"
export default component.exports